import { graphql } from '@teachino/shared-infrastructure';

export const migrateMaterialMutation = graphql(`
  mutation MigrateMaterial(
    $id: String!
    $contentHtml: MaterialContentHtmlInput
  ) {
    migrateMaterial(
      migrateMaterialInput: { id: $id, contentHtml: $contentHtml }
    ) {
      __typename
    }
  }
`);
